module.exports = __webpack_public_path__ + "img/test@2x.ac10ec55.png";